export default "__VITE_ASSET__CImb9IwY__"